"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function ButtonGroup({ className = '', children }) {
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: `inline mr-3 ${className}` }, { children: children }));
}
exports.ButtonGroup = ButtonGroup;
//# sourceMappingURL=ButtonGroup.js.map